import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})
export class TaskListComponent implements OnInit {

  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;

  constructor(private readonly breakpointObserver: BreakpointObserver,public mediaObserver : MediaObserver) { }

  ngOnInit(): void {
  this.mediaSub = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]).subscribe(result => {
    const breakpoints = result.breakpoints;

    this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
    this.deviceSm = breakpoints[Breakpoints.Small] || false;
    this.deviceMd = breakpoints[Breakpoints.Medium] || false;
    this.deviceLg = breakpoints[Breakpoints.Large] || false;
    this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
  });
  }

}
